import { Component } from '@angular/core';
import { ModalOverlayRef } from '../../modal-overlay-ref';

@Component({
    selector: 'gl-price-list-info',
    templateUrl: './price-list-info.component.html',
    styleUrls: ['./price-list-info.component.scss'],
    standalone: false
})
export class PriceListInfoComponent {
  constructor(private modalRef: ModalOverlayRef) {
    this.modalRef.backgroundClicked();
  }

  public close(result: boolean): void {
    this.modalRef.close(result);
  }
}
